<template>
  <div class="row">
    <div class="col-xs-12">
      <div class="box-controls mb-10">
        <div class="row">
          <div class="col-sm-12 col-md-4">
            <span class="small text-muted">Status:</span>
            <div data-toggle="btn-toggle" class="btn-group btn-group-xs pull-right">
              <button type="button" :class="['btn btn-success', item.is_active ? 'active' : '']"><i class="fa fa-check mr-5"></i>Aktiv</button>
              <button type="button" :class="['btn btn-danger', item.is_active ? '' : 'active']"><i class="fa fa-ban mr-5"></i>Inaktiv</button>
            </div>
            <hr class="visible-sm visible-xs">
          </div>
          <div class="col-sm-12 col-md-4 border-left border-right">
            <span class="small text-muted">Myplace:</span>
            <div data-toggle="btn-toggle" class="btn-group btn-group-xs pull-right">
              <button type="button" :class="['btn btn-success', item.show_in_list ? 'active' : '']"><i class="fa fa-check mr-5"></i>Ja</button>
              <button type="button" :class="['btn btn-danger', item.show_in_list ? '' : 'active']"><i class="fa fa-ban mr-5"></i>Nein</button>
            </div>
            <hr class="visible-sm visible-xs">
          </div>
          <div class="col-sm-12 col-md-4">
            <router-link  v-if="item.show_in_list" :to="`/accounting/companies/${company}/stores/${item.id}`">
              <button type="button" class="btn btn-outline btn-xs pull-right"><i class="fa fa-edit mr-5"></i>{{'edit' | translate}}</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-md-4 col-sm-6">
      <p>
        <small class="text-muted">Filialnummer:</small>
        <br>{{item.store_number}}<br>
        <small class="text-muted">WWS Filialnummer:</small>
        <br>{{ item.erp_store_id }}<br>
        <small class="text-muted">GLN:</small>
        <br>{{ item.gln }}<br>
        <small class="text-muted">Bestellemail:</small>
        <br>{{ item.order_email }}<br>
        <small class="text-muted">Click&amp;Collect Email:</small>
        <br>{{item.reservation_email}}<br>
        <small class="text-muted">SAP-Nummer:</small>
        <br>{{ item.sap_number}}</p>
    </div>
    <div class="col-xs-12 col-md-4 col-sm-6 border-left border-right">
      <p><small class="text-muted">Filialadresse:</small><br>{{ item.name }}<br>{{ item.street }} {{item.street_no}}<br>{{ item.zip_code }}
        {{ item.city }}<br><small>{{ item.country }}</small></p>
      <p><small class="text-muted">Versandadresse:</small><br>{{item.shipping_name}}<br>{{ item.shipping_street }} {{item.shipping_street_no}}<br>{{ item.shipping_zip_code }}
        {{ item.shipping_city }}<br><small>{{item.shipping_country}}</small></p>
    </div>
    <div class="col-xs-12 mt-10 mb-10 visible-sm visible-xs"></div>
    <div class="col-xs-12 col-md-4">
      <button @click="$emit('history',item.store_number)" type="button" data-toggle="modal" data-target="#mpHistory" class="btn btn-default btn-sm btn-block mb-10"><i class="fa fa-clock-o mr-5"></i>Marktplatzhistorie</button>
       <ul class="list-unstyled row" v-if="storeData && item.show_in_list">
         <template v-for="channel in Object.keys(storeData)">
           <store-table-row-button :store="item" :value="storeData[channel]" :channel="channel" :isAdditionalMarketplaces="false"></store-table-row-button>
         </template>
         <template v-if="additionalMarketplaces[item.gln]">
           <template v-for="channel in Object.keys(additionalMarketplaces[item.gln])">
             <store-table-row-button :store="item" :value="additionalMarketplaces[item.gln][channel]" :channel="channel" :isAdditionalMarketplaces="true"></store-table-row-button>
           </template>
         </template>
      </ul>
    </div>
    <div class="col-xs-12"><hr></div>
  </div>
</template>

<script>
import StoreTableRowButton from "./StoreTableRowButton";
export default {
  name: "StoreTableRow",
  components: {StoreTableRowButton},
  props: ['item', 'storeData', 'company', 'additionalMarketplaces'],
  methods: {
  },
  watch: {
    storeData(){
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/TableRows/StoreTableRow.vue